import { SharedModule } from './../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { LatestLocationCarComponent } from './latest-location-car.component';
import { LatestLocationCarResolver } from 'src/app/resolvers/latest-location-car.resolver';


export const routes: Routes = [
  { 
    path: '', 
    component: LatestLocationCarComponent, 
    pathMatch: 'full',
    resolve: {
        LatestLocationCarResolver
    }
  }
];

@NgModule({
  declarations: [LatestLocationCarComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule, 
    MatIconModule,
    ToastrModule.forRoot(),
    SharedModule
  ],
  exports: []
})
export class LatestLocationCarModule { }